import { Menu, LogOut } from 'lucide-react';

interface HeaderProps {
    title: string;
    onMenuToggle?: () => void;
    onLogout?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ title, onMenuToggle, onLogout }) => {
    return (
        <header className="main-header">
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-4)' }}>
                <button
                    className="btn btn-icon btn-ghost mobile-menu-btn"
                    onClick={onMenuToggle}
                >
                    <Menu size={20} />
                </button>
                <h1 className="page-title">{title}</h1>
            </div>

            <div className="header-actions" style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
                {onLogout && (
                    <button
                        className="btn btn-icon btn-ghost"
                        title="התנתקות"
                        onClick={onLogout}
                        style={{ color: 'var(--accent-500)' }}
                    >
                        <LogOut size={20} />
                    </button>
                )}
            </div>
        </header>
    );
};
